module.exports = __webpack_public_path__ + "static/media/marker-map.49e127ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/assets/img/marker-map.svg
// module id = 1418
// module chunks = 0